up.compiler('[accept-on-change]', (element) => {
  return up.on('change', () => {
    up.layer.accept(element.value)
  })
})
